import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';
import { LineChartComponent } from './line-chart/line-chart.component';

@NgModule({
  declarations: [DoughnutChartComponent, LineChartComponent],
  exports: [DoughnutChartComponent, LineChartComponent],
  imports: [
    CommonModule
  ]
})
export class ChartsModule { }
